import React from 'react'
import styled from 'styled-components'

const Message = styled.div`
  text-align: center;
  padding: 30px 20px;
  color: #8d95a6;
  font-size: 14px;
`

// keeps a single failing chart from taking down the whole dashboard
class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { failed: false, resetKey: props.resetKey }
  }

  static getDerivedStateFromError () {
    return { failed: true }
  }

  // give the chart another go once its query changed (filters, grouping, lender)
  static getDerivedStateFromProps (props, state) {
    if (props.resetKey === state.resetKey) return null

    return { failed: false, resetKey: props.resetKey }
  }

  componentDidCatch (error, info) {
    const { name } = this.props
    // eslint-disable-next-line no-console
    console.error(`Chart "${name}" failed to render`, error, info)
  }

  render () {
    const { children } = this.props
    const { failed } = this.state

    if (failed) return <Message>This chart could not be displayed.</Message>

    return children
  }
}

export default ErrorBoundary
